module.exports = __webpack_public_path__ + "static/fredrikstadkino.882bd8ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/assets/img/fredrikstadkino.png
// module id = 1418
// module chunks = 231608221292675